module.exports = __webpack_public_path__ + "img/plot_lock.30bcd95e.svg";